module.exports = __webpack_public_path__ + "assets/f7c9c82025243710b3dba59d6527cec6.png";